var data = {
	"body": "<path d=\"M919 298L740 106q-10-10-24-10H449l-1-66q0-3-.5-6.5T445 17t-4-5.5t-5-4.5t-6-3.5t-6.5-2.5t-7.5-1q-5 0-9.5 1.5T398 6t-6.5 6.5t-4 8T386 30l-1 66H32q-8 0-15.5 4.5T4.5 112T0 128v384q0 13 9.5 22.5T32 544h353v450q0 12 9.5 21t22.5 9t22.5-9t9.5-21V544h267q7 0 13-2.5t11-7.5l179-192q8-9 8.5-22t-8.5-22zM702 480H64V160h638l150 160z\" fill=\"currentColor\"/>",
	"width": 928,
	"height": 1024
};
exports.__esModule = true;
exports.default = data;
